export var TriggerAnalyticsKeys;
(function (TriggerAnalyticsKeys) {
    TriggerAnalyticsKeys["countryLanguage"] = "countryLanguage";
    TriggerAnalyticsKeys["siteIdentifier"] = "siteIdentifier";
    TriggerAnalyticsKeys["pnl"] = "pnl";
    TriggerAnalyticsKeys["clientName"] = "clientName";
    TriggerAnalyticsKeys["customerType"] = "customerType";
    TriggerAnalyticsKeys["product"] = "product";
    TriggerAnalyticsKeys["pageKind"] = "pageKind";
    TriggerAnalyticsKeys["pageName"] = "pageName";
    TriggerAnalyticsKeys["pageFunction"] = "pageFunction";
    TriggerAnalyticsKeys["pageSubFunction"] = "pageSubFunction";
    TriggerAnalyticsKeys["pathName"] = "pathName";
    TriggerAnalyticsKeys["token"] = "token";
    TriggerAnalyticsKeys["message"] = "message";
    TriggerAnalyticsKeys["messageType"] = "messageType";
    TriggerAnalyticsKeys["errorMessage"] = "errorMessage";
})(TriggerAnalyticsKeys || (TriggerAnalyticsKeys = {}));
export const dataObjects = {
    link: 'link',
    button: 'button'
};
export const dataTypes = {
    accountServices: 'account services',
    backToAccountManager: 'back to account manager',
    submit: 'submit',
    back: 'back',
    creditLimitIncrease: 'credit limit increase',
    cancel: 'cancel',
    tooltip: 'How does it impact my credit score?',
    requestIncrease: 'request increase',
    xButton: 'x button',
    close: 'close'
};
export const dataReasons = {
    saveCredit: 'Save your credit for your future purchase',
    backToAccountManager: 'back to account manager',
    submit: 'submit',
    back: 'back',
    xButton: 'x button',
    cancelButton: 'cancel',
    requestIncreaseButton: 'request increase',
    closeButton: 'close',
    requestIncrease: 'request increase first step',
    tooltipCreditLimit: 'how does it impact my credit score?',
    creditLimitIncrease: 'credit limit increase'
};
export const dataAnalytics = {
    clickTrackingEvent: 'clicktrackingevent'
};
export const backToAccountManagerDataProps = {
    'data-object': dataObjects.button,
    'data-type': dataTypes.backToAccountManager,
    'data-reason': dataReasons.saveCredit,
    'data-analytics': dataAnalytics.clickTrackingEvent
};
export const requestLimitIncreaseInitialStep = {
    'data-object': dataObjects.button,
    'data-type': dataTypes.accountServices,
    'data-reason': dataReasons.creditLimitIncrease,
    'data-analytics': dataAnalytics.clickTrackingEvent
};
export const cancelLimitIncreaseForm = {
    dataSecondaryObject: dataObjects.button,
    dataSecondaryType: dataTypes.cancel,
    dataSecondaryReason: '',
    'data-analytics': dataAnalytics.clickTrackingEvent
};
export const requestLimitIncrease = {
    dataPrimaryObject: dataObjects.button,
    dataPrimaryType: dataTypes.requestIncrease,
    dataPrimaryReason: '',
    'data-analytics': dataAnalytics.clickTrackingEvent
};
export const closeButton = {
    dataPrimaryObject: dataObjects.button,
    dataPrimaryType: dataTypes.close,
    dataPrimaryReason: '',
    'data-analytics': dataAnalytics.clickTrackingEvent
};
export const tooltipCreditLimit = {
    'data-object': dataObjects.button,
    'data-type': dataTypes.tooltip,
    'data-reason': dataReasons.tooltipCreditLimit,
    'data-analytics': dataAnalytics.clickTrackingEvent
};
export const triggerAnalyticsKeys = {
    countryLanguage: TriggerAnalyticsKeys.countryLanguage,
    siteIdentifier: TriggerAnalyticsKeys.siteIdentifier,
    pnl: TriggerAnalyticsKeys.pnl,
    clientName: TriggerAnalyticsKeys.clientName,
    customerType: TriggerAnalyticsKeys.customerType,
    product: TriggerAnalyticsKeys.product,
    pageKind: TriggerAnalyticsKeys.pageKind,
    pageName: TriggerAnalyticsKeys.pageName,
    pageFunction: TriggerAnalyticsKeys.pageFunction,
    pageSubFunction: TriggerAnalyticsKeys.pageSubFunction,
    pathName: TriggerAnalyticsKeys.pathName,
    token: TriggerAnalyticsKeys.token,
    message: TriggerAnalyticsKeys.message,
    messageType: TriggerAnalyticsKeys.messageType,
    errorMessage: TriggerAnalyticsKeys.errorMessage
};
export const analyticsValues = {
    error: 'error',
    errorMessage: 'sorry, something went wrong',
    vista: 'vista',
    digitalServicing: 'digital-servicing',
    view: 'view',
    submitted: 'submitted',
    creditLimitIncrease: 'credit_limit_increase',
    accountServices: 'account_services',
    activity: 'activity',
    approval: 'approval',
    partial_approval: 'partial_approval',
    request: 'request'
};
export const cliAnalyticsModalDefault = {
    pageKind: analyticsValues.activity,
    pageFunction: analyticsValues.creditLimitIncrease,
    pageSubFunction: analyticsValues.accountServices,
    pageName: analyticsValues.request
};
export const cliAnalyticsRequestError = {
    ...cliAnalyticsModalDefault,
    errorMessage: 'cli modal request error'
};
export const cliAnalyticsRequestApproval = {
    ...cliAnalyticsModalDefault,
    pageName: 'approval'
};
export const cliAnalyticsRequestDecline = {
    ...cliAnalyticsModalDefault,
    pageName: 'decline',
    message: 'cli decline'
};
export const cliAnalyticsRequestPartialApproval = {
    ...cliAnalyticsModalDefault,
    pageName: 'partial-approval'
};
export const cliAnalyticsError = {
    ...cliAnalyticsModalDefault,
    pageName: 'error',
    errorMessage: 'Unfortunately we are unable to process your request at this time. Please try again later.'
};
